/* import { init as initMainProduct } from "../sections/main-product";
 */
import { init as initMainProductRecommendations } from "../sections/main-product-recommendations";
import { getOmnibusPriceFromAPI, renderOmnibusPriceFromAPI } from '../vendor/omnibus.js';

export function init() {
  /*
  const mainProductElement = document.querySelector(
    ".shopify-section.main-product"
  );
   if (mainProductElement instanceof HTMLElement) {
    initMainProduct(mainProductElement);
  } */

  const mainProductRecommendationsElement = document.querySelector(
    ".shopify-section.main-product-recommendations"
  );
  if (mainProductRecommendationsElement instanceof HTMLElement) {
    initMainProductRecommendations(mainProductRecommendationsElement);
  }
}

function main() {

  const renderOmnibusPrice = async (variantID, variantPrice, hasPromo) => {
    const brand = document.getElementById('omnibusprice')?.dataset.omnibus_brand;
    if (!brand) return;
    renderOmnibusPriceFromAPI(brand, await getOmnibusPriceFromAPI(brand, variantID), variantPrice, hasPromo);
  };

  const omnibusPriceContainer = document.getElementById('omnibusprice');
  const variantID = omnibusPriceContainer?.dataset.omnibus_id;
  const variantPrice = omnibusPriceContainer?.dataset.variant_price;
  const hasPromo = omnibusPriceContainer?.dataset.has_promo;

  renderOmnibusPrice(variantID, variantPrice, hasPromo);
}

document.addEventListener("DOMContentLoaded", main);